"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _DeleteFooter = require("./DeleteFooter");
var _DeleteBody = require("./DeleteBody");
var _DeleteHeader = require("./DeleteHeader");
var styles = {
  "modal": "DeleteAssetModal__modal__fskZE",
  "header": "DeleteAssetModal__header__YstUx",
  "body": "DeleteAssetModal__body__2lJ_d",
  "footer": "DeleteAssetModal__footer__3EAoC",
  "title": "DeleteAssetModal__title__1dr9Z",
  "text": "DeleteAssetModal__text__FGBfZ",
  "icon": "DeleteAssetModal__icon__h8VY1",
  "warning": "DeleteAssetModal__warning__F0gIV",
  "message": "DeleteAssetModal__message__3wWeG",
  "dependents": "DeleteAssetModal__dependents__3tWFG",
  "subtitle": "DeleteAssetModal__subtitle__2-sRR",
  "versions-container": "DeleteAssetModal__versions-container__1_VSg",
  "versionsContainer": "DeleteAssetModal__versions-container__1_VSg",
  "open-icon": "DeleteAssetModal__open-icon__X5xPP",
  "openIcon": "DeleteAssetModal__open-icon__X5xPP",
  "modal-lg": "DeleteAssetModal__modal-lg__-37XX",
  "modalLg": "DeleteAssetModal__modal-lg__-37XX"
}; 
require('./DeleteAssetModal.css');
var oneRemainingVersion = function oneRemainingVersion(assetVersions) {
  return assetVersions.length === 1;
};
var useInitialDeleteType = function useInitialDeleteType(asset) {
  var isHardDeletionSettingEnabled = (0, _exchangeReactHooks.useFeatureFlag)('org-level-settings-enabled');
  var assetIsInDevelopment = asset.status === 'development';
  if (!isHardDeletionSettingEnabled) {
    return undefined;
  }
  if (assetIsInDevelopment) {
    return 'hard';
  }
  return 'soft';
};
var DeleteAssetModal = function DeleteAssetModal(_ref) {
  var asset = _ref.asset,
    assetVersions = _ref.assetVersions,
    config = _ref.config,
    onClose = _ref.onClose,
    theme = _ref.theme,
    onDelete = _ref.onDelete,
    className = _ref.className,
    hasDeleteError = _ref.hasDeleteError,
    isDeletingAsset = _ref.isDeletingAsset,
    dependents = _ref.dependents,
    isDeleteBlocked = _ref.isDeleteBlocked,
    renderErrorDescription = _ref.renderErrorDescription,
    renderPreprocessingDelete = _ref.renderPreprocessingDelete,
    renderDependents = _ref.renderDependents,
    _ref$isPreprocessingD = _ref.isPreprocessingDelete,
    isPreprocessingDelete = _ref$isPreprocessingD === void 0 ? false : _ref$isPreprocessingD,
    headerTitle = _ref.headerTitle,
    displayVersionAsMinor = _ref.displayVersionAsMinor,
    _ref$isPortalReArchit = _ref.isPortalReArchitectureEnabled,
    isPortalReArchitectureEnabled = _ref$isPortalReArchit === void 0 ? false : _ref$isPortalReArchit;
  var canDelete = !(isDeleteBlocked || hasDeleteError);
  var isLastVersion = oneRemainingVersion(assetVersions);
  var initialDeleteType = useInitialDeleteType(asset);
  var _React$useState = _react.default.useState(initialDeleteType),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    deleteType = _React$useState2[0],
    setDeleteType = _React$useState2[1];
  var handleDelete = _react.default.useCallback(function () {
    onDelete(asset, deleteType);
  }, [onDelete, asset, deleteType]);
  var handleDeleteTypeChange = _react.default.useCallback(function (newDeleteType) {
    setDeleteType(newDeleteType);
  }, [setDeleteType]);
  var labelId = 'delete-asset-modal-title';
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    testId: "delete-modal",
    theme: theme,
    renderInBody: false,
    onEsc: onClose,
    onClickOverlay: onClose,
    className: (0, _classnames.default)(styles.modal, (0, _defineProperty2.default)({}, styles.modalLg, isPortalReArchitectureEnabled), className),
    ariaLabelledBy: labelId,
    role: "alertdialog"
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    testId: "modal-header",
    className: styles.header,
    isDanger: true
  }, /*#__PURE__*/_react.default.createElement(_DeleteHeader.DeleteHeader, {
    hasDeleteError: hasDeleteError,
    headerTitle: headerTitle,
    isLastVersion: isLastVersion,
    canDelete: canDelete,
    labelId: labelId
  })), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "modal-body",
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement(_DeleteBody.DeleteBody, {
    isPreprocessingDelete: isPreprocessingDelete,
    renderPreprocessingDelete: renderPreprocessingDelete,
    hasDeleteError: hasDeleteError,
    renderDependents: renderDependents,
    dependents: dependents,
    isDeleteBlocked: isDeleteBlocked,
    renderErrorDescription: renderErrorDescription,
    config: config,
    asset: asset,
    displayVersionAsMinor: displayVersionAsMinor,
    isLastVersion: isLastVersion,
    onDeleteTypeChange: handleDeleteTypeChange
  })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "modal-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_DeleteFooter.DeleteFooter, {
    isDeletingAsset: isDeletingAsset,
    isPreprocessingDelete: isPreprocessingDelete,
    isLastVersion: isLastVersion,
    canDelete: canDelete,
    onClose: onClose,
    handleDelete: handleDelete,
    isPortalReArchitectureEnabled: isPortalReArchitectureEnabled
  })));
};
var _default = exports.default = DeleteAssetModal;
//# sourceMappingURL=DeleteAssetModal.js.map